import { appUser } from '@/utils'
import { wechatService } from '@/api'
import { getCookie } from '@/utils/common/cookie'

export const $wx = {
  /**
   * 设置页面标题
   */
  setTitle(title) {
    document.title = title
    const mobile = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(mobile)) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.setAttribute('src', '')
      const iframeCallback = function () {
        setTimeout(function () {
          iframe.removeEventListener('load', iframeCallback)
          document.body.removeChild(iframe)
        }, 0)
      }

      iframe.addEventListener('load', iframeCallback)
      document.body.appendChild(iframe)
    }
  },

  config(wxConfig) {
    return new Promise((resolve, reject) => {
      console.log('wxConfig.appId,', wxConfig.appId)
      if (!wxConfig) {
        console.log('JSSDK 配置错误')
        return reject('JSSDK 配置错误')
      }
      if (window.wx == null) {
        return reject('JSSDK 未加载')
      }
      window.wx.config({
        debug: false,
        appId: wxConfig.appId,
        timestamp: wxConfig.timestamp + '',
        nonceStr: wxConfig.nonceStr + '',
        signature: wxConfig.signature,
        jsApiList: [
          'chooseWXPay',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'hideMenuItems',
          'hideOptionMenu',
          'chooseImage',
          'getLocalImgData'
        ],
        openTagList: ['wx-open-launch-app'] // 填入打开小程序的开放标签名
      })
      window.wx.ready(() => {
        console.log('[WXLogin] wx.ready')
        resolve({ ok: true })
      })
      window.wx.error(e => {
        console.error('[WXLogin] wx.error' + e.errMsg)
        // reject(e.errMsg);
      })
    })
  }

  // hideMenus() {
  //   window.wx.hideOptionMenu();
  //   // window.wx.hideMenuItems();
  // }
}

const JWEIXIN = 'jweixin'

/**
 * 初始化jssdk配置
 */
export function isWxAndJssdkConfig() {
  if (appUser.isNative) return Promise.reject()
  console.log('xn wx1 isWxAndJssdkConfig')
  const getJssdkConfig = (resolve, reject) => {
    console.log('xn wx getJssdkConfig')
    const appId = 'ylyk' // 默认公众号编码
    const localhost = location.host.indexOf('localhost') >= 0
    // 分享的地址
    const shareUrl = localhost // 编码URL地址
      ? // 本地去测试环境登录
        `https://new-wx-test.ylyk.com/payment.html?port=test&appname=ylyk_pub_test&shareCode=Z29vZHNJZD0yNDA0OCZ1c2VySWQ9MQ==#/goods`
      : // 本地去正式环境登录
        // ? 'https://new-wx.ylyk.com/payment.html?shareCode=Z29vZHNJZD0yNDA0OCZ1c2VySWQ9MQ==#/goods'
        location.href
    const config = wechatService.getJssdkConfig({ appId, openId: 'openId', url: shareUrl })
    console.log('xn wx config', config)
    config
      .then(appConfig => {
        console.log('xn wx appConfig', appConfig)
        window.wx_app = appConfig
        // 注册微信服务
        $wx
          .config(appConfig)
          .then(res => {
            // this.wxStatus = res
            console.log('xn wx:', res)
            resolve(appConfig)
          })
          .catch(error => {
            console.error(error)
            reject(error)
          })
      })
      .catch(error => {
        reject(error)
      })
  }

  return new Promise((resolve, reject) => {
    const { loadModules } = window
    if (loadModules[JWEIXIN] == null) {
      // 加载完后再初始化
      loadModules[JWEIXIN] = {}
      loadModules[JWEIXIN].callback = () => {
        getJssdkConfig(resolve, reject)
      }
    } else {
      // 初始化
      getJssdkConfig(resolve, reject)
    }
  })
}

export function isWeixin() {
  var ua = navigator.userAgent.toLowerCase()
  return /MicroMessenger/i.test(ua)
}
export function isAlipay() {
  var ua = navigator.userAgent.toLowerCase()
  console.log('/AlipayClient/i.test(ua)', /AlipayClient/i.test(ua))
  return /AlipayClient/i.test(ua)
}

export function isNative() {
  const android = getCookie('appVersionAndroid')
  const ios = getCookie('appVersioniOS')
  return Boolean(android || ios)
}

export default $wx
